import React, { useEffect, useState } from "react";
import { FaTimes } from "react-icons/fa";

export default function SheetVisibilityModal({
  handleSheetVisibilityModal,
  sheetNameBtm,
  unhideSheet, // Accepting unhideSheet as a prop
}) {
  const hiddenSheets = sheetNameBtm.filter(
    (sheet) => sheet.isSheetVisible === false
  );
  const [unhideClickable, setUnhideClickable] = useState(false);
  const [sheetVisibility, setSheetVisibility] = useState(
    hiddenSheets.map((sheet) => ({
      ID: sheet.ID,
      SheetName: sheet.SheetName,
      isSheetVisible:
        sheet.isSheetVisible !== undefined ? sheet.isSheetVisible : true, // Default to true if undefined
    }))
  );

  const handleCheckboxChange = (ID) => {
    setSheetVisibility((prevState) =>
      prevState.map((sheet) =>
        sheet.ID === ID
          ? { ...sheet, isSheetVisible: !sheet.isSheetVisible }
          : sheet
      )
    );
  };

  const handleSave = () => {
    sheetVisibility.forEach((sheet) => {
      if (sheet.isSheetVisible) {
        unhideSheet(sheet.ID); // Call unhideSheet for visible sheets
      }
    });
    handleSheetVisibilityModal();
  };

  useEffect(() => {
    const checkedSheets = sheetVisibility.filter(
      (sheet) => sheet.isSheetVisible === true
    );
    setUnhideClickable(checkedSheets.length > 0); // Reset unhideClickable based on selection
  }, [sheetVisibility]);

  return (
    <main className="fixed inset-0 flex items-center justify-center z-30">
      <section className="flex flex-col items-center justify-between gap-4 relative p-4 border rounded-lg shadow-lg bg-white w-[30vw] h-[19rem] overflow-hidden">
        <header>
          <h4 className="absolute top-2 left-4 text-black cursor-pointer text-lg font-medium w-full">
            Select Sheets to Unhide
          </h4>
          <button onClick={handleSheetVisibilityModal}>
            <FaTimes className="absolute top-2 right-4 text-gray-500 cursor-pointer hover:text-black" />
          </button>
        </header>

        <section
          className="flex flex-col gap-2 py-1 px-1 mt-3 border w-full"
          style={{ height: "12rem", overflowY: "auto" }} // Fixed height for 4 sheets, scrollable
        >
          {sheetVisibility.length === 0 ? (
            <div className="text-gray-500 text-center">No sheets available</div>
          ) : (
            sheetVisibility.map((sheet) => (
              <label key={sheet.ID} className="flex items-center mb-2">
                <input
                  type="checkbox"
                  checked={sheet.isSheetVisible}
                  onChange={() => handleCheckboxChange(sheet.ID)}
                  className={`mr-2 text-xl h-4 w-4 font-medium ${
                    sheet.isSheetVisible ? "text-black" : "text-gray-500"
                  }`}
                />
                <span
                  className={`${
                    sheet.isSheetVisible ? "text-black" : "text-gray-500"
                  }`}
                >
                  {sheet.SheetName}
                </span>
              </label>
            ))
          )}
        </section>

        <footer className="w-full items-center justify-end flex">
          <button
            className={`self-end bg-blue-950 text-white px-4 py-2 rounded ${
              unhideClickable ? "" : "opacity-50 cursor-not-allowed"
            }`}
            onClick={unhideClickable ? handleSave : undefined}
          >
            Unhide
          </button>
        </footer>
      </section>
    </main>
  );
}
